import { lazy } from 'react';

import { array, pipe, struct } from '@code-expert/prelude';
import { concatRoutes } from '/imports/modules/Routing';
import { quizNavSelectionAdt } from '../../shared/presentation/navigation';
import { solveQuestionRoute, solveQuizRoute, solveQuizSummaryRoute } from './routes';
import { solveQuizApi } from './SolveQuizApi';
import { SolveQuizSummary } from './SolveQuizSummary';

const SolveQuizPage = lazy(async () => {
  const { SolveQuizPage } = await import('./SolveQuizPage');
  return { default: SolveQuizPage };
});

const SolveQuestion = lazy(async () => {
  const { SolveQuestion } = await import('./SolveQuestion');
  return { default: SolveQuestion };
});

const SolveQuiz = lazy(async () => {
  const { SolveQuiz } = await import('./SolveQuiz');
  return { default: SolveQuiz };
});

export const solveQuizRouter = concatRoutes([
  solveQuizSummaryRoute.parser.map(({ taskId, attemptId }) => (
    <SolveQuizPage
      api={solveQuizApi}
      taskId={taskId}
      attemptId={attemptId}
      selection={quizNavSelectionAdt.summary()}
    >
      {({ quiz }) => (
        <SolveQuizSummary taskId={taskId} attemptId={attemptId} quiz={quiz} api={solveQuizApi} />
      )}
    </SolveQuizPage>
  )),
  solveQuestionRoute.parser.map(({ taskId, attemptId, questionId }) => (
    <SolveQuizPage
      api={solveQuizApi}
      taskId={taskId}
      attemptId={attemptId}
      selection={quizNavSelectionAdt.question(questionId)}
    >
      {({ quiz }) => (
        <SolveQuiz quiz={quiz} key="solve-question">
          <SolveQuestion
            api={solveQuizApi}
            attemptId={attemptId}
            questionId={questionId}
            questionIds={pipe(quiz.questions, array.map(struct.get('questionId')))}
            taskId={taskId}
          />
        </SolveQuiz>
      )}
    </SolveQuizPage>
  )),
  solveQuizRoute.parser.map(({ taskId, attemptId }) => (
    <SolveQuizPage
      api={solveQuizApi}
      taskId={taskId}
      attemptId={attemptId}
      selection={quizNavSelectionAdt.quiz()}
    >
      {({ quiz }) => <SolveQuiz quiz={quiz} fullDescription />}
    </SolveQuizPage>
  )),
]);
